import React from "react";
import { PieChart, Pie, Cell } from "recharts";
const COLORS = ["#9AC03B", "#707070"];
const RADIAN = Math.PI / 180;
export default function SummeryPieChart({ data }) {
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (React.createElement("text", { x: x, y: y, fontSize: '20px', fill: "white", textAnchor: 'middle', dominantBaseline: "central" }, `${(percent * 100).toFixed(0)}%`));
    };
    return (React.createElement(PieChart, { width: 400, height: 300 },
        React.createElement(Pie, { data: data, dataKey: "value", cx: 130, cy: 150, innerRadius: 70, outerRadius: 130, paddingAngle: 3, startAngle: 90, endAngle: -360, labelLine: false, label: renderCustomizedLabel }, data === null || data === void 0 ? void 0 : data.map((entry, index) => {
            return (React.createElement(Cell, { key: `cell-${index}`, fill: COLORS[index % COLORS.length] }));
        }))));
}
